import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import severityService from './severitiesService'

//set initial state
const initialState = {
    severities: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}

//get all severities
export const getSeverities = createAsyncThunk(
    'severities/getAll',
    async (_, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.user.token
            return await severityService.getSeverities(_, token)
        } catch (error) {
            const message = (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

//Severity Slice
export const severitySlice = createSlice({
    name: 'severities',
    initialState,
    reducers: {
        reset:(state) => initialState,
    },
    extraReducers: (builder) => {
        builder
        .addCase(getSeverities.pending, (state) => {
            state.isLoading = true
        })
        .addCase(getSeverities.fulfilled, (state, action) => {
            state.isLoading = false
            state.isSuccess = true
            state.severities = action.payload
        })
        .addCase(getSeverities.rejected, (state, action) => {
            state.isLoading = false
            state.isError = true
            state.message = action.payload
        })
    }
})

export const {reset} = severitySlice.actions
export default severitySlice.reducer
